/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const genderJson = async (): Promise<any> => {
  const gender = useJSONStore.getState().gender;
  const token = useUserStore.getState().userToken;
  const setGender = useJSONStore.getState().setGender;

  if (gender.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.gender}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setGender(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default genderJson;
